import "./Privacy.module.css";
import Header from "@/reusable_sections/Header";
import PolTicaDePrivacidad from "./sections/PolTicaDePrivacidad";
import Legalbasis from "./sections/Legalbasis";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPage() {
  return <div>
      <Header />
      <PolTicaDePrivacidad />
      <Legalbasis />
      <Footer />
    </div>;
}